// App.jsx
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './Components/Navbar';
import Home from './Pages/Home';
import Photography from './Pages/Photography';
import Design from './Pages/Design';
import './Pages/pages.css';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        {/* We will add Photography and Design routes here next */}
        <Route path="/photography" element={<Photography/>} />
        <Route path="/design" element={<Design/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;